import React, { useEffect } from "react";
import { useField } from "formik";

const UsageType = {
    ONCE: "Once",
    MULTIPLE: "Multiple",
}

const UsageBehaviourInput = ({ fieldName, value, disabledOnceOption, disabledMultipleOption }) => {
    const [,, formikHelper] = useField(fieldName);

    useEffect(() => {
        if (!value) {
            formikHelper.setValue(disabledOnceOption);
        }
    }, [disabledOnceOption]);

    return (
        <div role="group" className="mt-2">
            <label className="mb-2">This code can be used per user:</label>
            <div className="m-0 d-flex gap-24px">
                <div className="d-flex align-items-center">
                    <div className="custom-control custom-radio mb-3 custom-z-index">
                        <input
                            type="radio"
                            name={fieldName}
                            id="customRadio1"
                            className="custom-control-input custom-z-index"
                            value={UsageType.ONCE}
                            checked={!value}
                            disabled={disabledOnceOption}
                            onChange={() => formikHelper.setValue(false)}
                        />
                        <label
                            className="custom-control-label"
                            htmlFor="customRadio1"
                        >
                            {UsageType.ONCE}
                        </label>
                    </div>
                </div>
                <div className="custom-control custom-radio mb-3 custom-z-index d-inline-flex align-items-center">
                    <div>
                        <input
                            type="radio"
                            name={fieldName}
                            id="customRadio2"
                            className="custom-control-input custom-z-index"
                            value={UsageType.MULTIPLE}
                            checked={value}
                            disabled={disabledMultipleOption}
                            onChange={() => formikHelper.setValue(true)}
                        />
                      <label
                          className="custom-control-label"
                          htmlFor="customRadio2"
                      >
                          {UsageType.MULTIPLE}
                      </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UsageBehaviourInput;
